import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarTile } from "@perxis-auto/ui-kit/lib/components/CarTile";
const TileTable = memo(function TileTable2({ isLoading = false, items, ...props }) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(CarTile.TableSkeleton, {});
  }
  if (!(items == null ? void 0 : items.length)) {
    return null;
  }
  return /* @__PURE__ */ jsx(CarTile.Table, { items, ...props });
});
export {
  TileTable
};
